import {
  DoryMessageType,
  DoryServiceType,
  DoryStreamingHeader,
  DoryStreamingMessage,
} from '../../abstract/StreamingMessages';

function getBrokerageTradingHeader(
  messageType: DoryMessageType
): DoryStreamingHeader {
  return {
    service: DoryServiceType.BROKERAGE_TRADING,
    messageType,
    version: 'v1',
  };
}

type BrokerageTradingSubscribePayload = Record<string, never>;

type BrokerageTradingPayload = Record<string, never>;

export { BrokerageTradingPayload, getBrokerageTradingHeader };
//#region Subscribe
type BrokerageTradingSubscribeHeader = {
  messageId?: string;
} & DoryStreamingHeader;

type BrokerageTradingSubscribeRequest = {
  header: BrokerageTradingSubscribeHeader;
} & DoryStreamingMessage;

type BrokerageTradingSubscribeResponse = {
  header: BrokerageTradingSubscribeHeader;
  payload: BrokerageTradingPayload[];
} & DoryStreamingMessage;

function getBrokerageTradingSubscribeRequest(): BrokerageTradingSubscribeRequest {
  return {
    header: getBrokerageTradingHeader(DoryMessageType.SUBSCRIBE),
  };
}

export {
  BrokerageTradingSubscribeHeader,
  BrokerageTradingSubscribeRequest,
  BrokerageTradingSubscribeResponse,
  BrokerageTradingSubscribePayload as BrokerageTradingRequestPayload,
  getBrokerageTradingSubscribeRequest,
};
//#endregion

//#region Unsubscribe
type BrokerageTradingUnsubscribeRequest = {
  header: DoryStreamingHeader;
};

type BrokerageTradingUnsubscribeResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getBrokerageTradingUnsubscribeRequest(): BrokerageTradingUnsubscribeRequest {
  return {
    header: getBrokerageTradingHeader(DoryMessageType.UNSUBSCRIBE),
  };
}

export {
  BrokerageTradingUnsubscribeRequest,
  BrokerageTradingUnsubscribeResponse,
  getBrokerageTradingUnsubscribeRequest,
};
//#endregion

//#region Update
type BrokerageTradingUpdateResponse = {
  payload: BrokerageTradingPayload;
} & DoryStreamingMessage;

export { BrokerageTradingUpdateResponse };
//#endregion
